/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.TOGGLE_SIDEBAR]: state => {
    state.sidebarCollapsed = !state.sidebarCollapsed;
  },
  [types.TOGGLE_FULLSCREEN]: state => {
    state.fullscreen = !state.fullscreen;
  },
};



// WEBPACK FOOTER //
// ./src/store/app/mutations.js